module.exports = __webpack_public_path__ + "img/2gis.cc3d6c3.svg";